import { useState } from 'react';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new URLSearchParams();
    const elements = form.elements;

    // Validate textarea length
    const messageField = form.querySelector('textarea[name="message"]') as HTMLTextAreaElement;
    if (messageField && messageField.value.length > 500) {
      alert('Message must be 500 characters or less.');
      return;
    }

    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (el.name && el.value) {
        formData.append(el.name, el.value);
      }
    }

    try {
      await fetch('https://readdy.ai/api/form/d7jt03l1p46osftjrtcg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <section id="contact" className="bg-[#0d0d0d] py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">Get In Touch</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left */}
          <div>
            <h2 className="text-white font-bold leading-tight mb-6" style={{fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>
              Let&apos;s Build<br />Something Great
            </h2>
            <p className="text-white/50 text-base leading-relaxed mb-10">
              Whether you&apos;re an artist looking for a track, a label, or you wanting to work with our roster — Andreas and the AceAge-Music Team want to hear from you.
            </p>

            {/* Contact details */}
            <div className="space-y-6">
              {[
                { icon: 'ri-map-pin-line', label: 'Location', value: 'Germany · World-wide' },


              ].map(item => (
                <div key={item.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center border border-white/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-white/40 text-base`} />
                  </div>
                  <div>
                    <p className="text-white/30 text-xs tracking-widest uppercase">{item.label}</p>
                    <p className="text-white/70 text-sm">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Form */}
          <div>
            {submitted ? (
              <div className="h-full flex flex-col items-center justify-center text-center py-16">
                <div className="w-16 h-16 flex items-center justify-center border border-white/20 rounded-full mb-6">
                  <i className="ri-check-line text-white text-2xl" />
                </div>
                <h3 className="text-white font-semibold text-xl mb-3">Message Sent!</h3>
                <p className="text-white/50 text-sm">Thanks for reaching out. Andreas and the team will get back to you shortly.</p>
              </div>
            ) : (
              <form
                id="contact-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="text-white/40 text-xs tracking-widest uppercase block mb-2">Name</label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Your name"
                      className="w-full bg-white/[0.05] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="text-white/40 text-xs tracking-widest uppercase block mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="your@email.com"
                      className="w-full bg-white/[0.05] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="text-white/40 text-xs tracking-widest uppercase block mb-2">Inquiry Type</label>
                  <select
                    name="inquiry_type"
                    className="w-full bg-white/[0.05] border border-white/10 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-white/30 transition-colors appearance-none cursor-pointer"
                  >
                    <option value="production" className="bg-[#111]">Music Production</option>
                    <option value="mastering" className="bg-[#111]">Mastering Services</option>
                    <option value="other" className="bg-[#111]">Other</option>
                  </select>
                </div>

                <div>
                  <label className="text-white/40 text-xs tracking-widest uppercase block mb-2">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    required
                    placeholder="What's this about?"
                    className="w-full bg-white/[0.05] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                  />
                </div>

                <div>
                  <label className="text-white/40 text-xs tracking-widest uppercase block mb-2">
                    Message <span className="text-white/20 normal-case tracking-normal">(max 500 chars)</span>
                  </label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    placeholder="Tell us about your project, vision, or how we can help..."
                    className="w-full bg-white/[0.05] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors resize-none"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-white text-black font-semibold py-4 rounded-full hover:bg-white/90 transition-colors text-sm tracking-wide cursor-pointer whitespace-nowrap"
                >
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
